import { Page, Text, View, Document, StyleSheet, Font } from "@react-pdf/renderer";

// ✅ Register the custom font (Ensure the correct path)
Font.register({
    family: "NotoSans",
    src: "/fonts/NotoSans-VariableFont_wdth,wght.ttf", // Adjust the path based on your project structure
});

// Define styles for the PDF
const styles = StyleSheet.create({
    page: { padding: 20 },
    title: { fontSize: 18, marginBottom: 10, fontFamily: "NotoSans" },
    text: { fontSize: 12, marginBottom: 5, fontFamily: "NotoSans" },
});

const ProviderPDF = ({ provider }) => (
    <Document>
        <Page style={styles.page}>
            <View>
                <Text style={styles.title}>{provider.name}</Text>
                <Text style={styles.text}>Region: {provider.region}</Text>
                <Text style={styles.text}>City: {provider.city}</Text>
                {provider.description && <Text style={styles.text}>Description: {provider.description}</Text>}
                {provider.emails?.length > 0 && (
                    <Text style={styles.text}>Emails: {provider.emails.join(", ")}</Text>
                )}
                {provider.phones?.length > 0 && (
                    <Text style={styles.text}>Phones: {provider.phones.join(", ")}</Text>
                )}
                {provider.website && <Text style={styles.text}>Website: {provider.website}</Text>}
            </View>
        </Page>
    </Document>
);

export default ProviderPDF;
